import React from "react";
import classes from "../Management.module.scss";
import styles from "./DealerPipeline.module.scss";
import { US_PORTS } from "../../../services/dealerStock";

// The quote form stores ports in capitals ("FREEPORT (TEXAS)"); staff read them
// as names.
export const portName = (port) => String(port || "").toLowerCase().replace(/\b[a-z]/g, (c) => c.toUpperCase());

/**
 * What a sale is priced as - shipped to a US port or fully imported, which
 * port, and the title service - as form fields for a grid. The sale form, the
 * sale's Details tab and a new car invoice all edit the sale's `quote` with it.
 *
 * Props:
 *   quote     { quoteType: 'shipped' | 'imported' | '', port, includeTitle }
 *   onChange(quote)
 *   inUs      a car already in the US: no shipping or import, only the title
 *   disabled
 */
const QuoteFields = ({ quote, onChange, inUs = false, disabled = false }) => {
  const set = (key, value) => onChange({ ...quote, [key]: value });
  // A port typed in before the list existed stays selectable.
  const ports = quote.port && !US_PORTS.includes(quote.port) ? [quote.port, ...US_PORTS] : US_PORTS;
  return (
    <>
      {!inUs && (
        <div className={classes.formGroup}>
          <label className={classes.formLabel}>Shipped or imported</label>
          <select className={classes.formInput} value={quote.quoteType || ""} disabled={disabled} onChange={(e) => set("quoteType", e.target.value)}>
            <option value="">Not chosen yet (priced as shipped)</option>
            <option value="shipped">Shipped to port</option>
            <option value="imported">Fully imported (duty &amp; port fees)</option>
          </select>
        </div>
      )}
      {!inUs && (
        <div className={classes.formGroup}>
          <label className={classes.formLabel}>US port</label>
          <select className={classes.formInput} value={quote.port || ""} disabled={disabled} onChange={(e) => set("port", e.target.value)}>
            <option value="">Not chosen yet</option>
            {ports.map((p) => <option key={p} value={p}>{portName(p)}</option>)}
          </select>
        </div>
      )}
      <label className={styles.checkboxRow}>
        <input type="checkbox" checked={!!quote.includeTitle} disabled={disabled} onChange={(e) => set("includeTitle", e.target.checked)} />
        US title service
      </label>
    </>
  );
};

export default QuoteFields;
